export default __webpack_public_path__ + "static/media/logout.787a5fa3.svg";